/*=============================================================================
  Ella Custom JS - Customize The Style For Layout
=============================================================================*/

document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(
    'button[name="add"], .product-card__add-to-cart'
  );

  const restrictedButtons = [];

  buttons.forEach(function (btn) {
    const parent = btn.closest("[data-product-tags]");

    if (!parent) {
      return;
    }

    const tags = parent.dataset.productTags || "";

    if (tags.includes("frozen_dubai_only")) {
      restrictedButtons.push(btn);
    } else {
      btn.style.display = "inline-block";
      btn.disabled = false;
      btn.style.opacity = "1";
      btn.style.cursor = "pointer";
    }
  });

  // No restricted products = no GeoIP request needed
  if (!restrictedButtons.length) {
    return;
  }

  fetch("https://ipapi.co/json/")
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      const country = data.country_name || "";
      const city = data.city ? data.city.toLowerCase() : "";

      const isDubaiCustomer =
        country === "United Arab Emirates" && city === "dubai";

      restrictedButtons.forEach(function (btn) {
        if (isDubaiCustomer) {
          btn.style.display = "inline-block";
          btn.disabled = false;
          btn.style.opacity = "1";
          btn.style.cursor = "pointer";
        } else {
          btn.style.display = "none";
        }
      });
    })
    .catch(function (error) {
      console.error("GeoIP error:", error);

      restrictedButtons.forEach(function (btn) {
        btn.style.display = "none";
      });
    });
});

/*=============================================================================
  IMPORTANT DISCLAIMER
  Please use only JS to style the layout.
=============================================================================*/